export const SET_FOLLOWUP_LOADING = 'SET_FOLLOWUP_LOADING'
export const SET_FOLLOWUP = 'SET_FOLLOWUP'
export const ADD_FOLLOWUP = 'ADD_FOLLOWUP'
export const EDIT_FOLLOWUP = 'EDIT_FOLLOWUP'
export const DELETE_FOLLOWUP = 'DELETE_FOLLOWUP'
export const SET_FOLLOWUP_ACTIVE_INDEX = 'SET_FOLLOWUP_ACTIVE_INDEX'

export const ADD_REPLAY = 'ADD_REPLAY'
export const FETCH_COMMENTS = 'FETCH_COMMENTS'